import type { Order } from './libs/type'

import OrderAddress from './components/OrderAddress'
import OrderMeta from './components/OrderMeta'
import { OrderProductItem } from './components/OrderProductItem'
import OrderStatus from './components/OrderStatus'
import OrderSummary from './components/OrderSummary'
import PaymentDetail from './components/PaymentDetail'

interface OrderHistoryDetailProps {
  order: Order
}

export function OrderHistoryDetail({
  order,
}: Readonly<OrderHistoryDetailProps>) {
  return (
    <div className="mx-auto grid grid-cols-1 gap-10 divide-y border bg-white p-10 [&>*:not(:first-child)]:pt-10">
      <div className="relative">
        <h2 className="text-xl font-medium">Order Details</h2>
        <p>#{order.orderId}</p>
        <div className="absolute right-0 top-0">
          <OrderStatus status={order.status} />
        </div>
      </div>
      <OrderMeta
        createdDate={new Date(order.createdDate)}
        email={order.billing.email}
        paymentMethodTitle={order.paymentMethodTitle}
        total={order.total}
      />
      <PaymentDetail order={order} />
      <section className="grid gap-10 md:flex md:justify-between">
        <OrderAddress address={order.billing} type={'billing'} />
        <OrderAddress address={order.shipping} type={'shipping'} />
      </section>
      <section>
        <div>
          {order?.orderItems?.map((item, index) => (
            <OrderProductItem key={index} {...item} />
          ))}
        </div>
        <div className="mt-10">
          <OrderSummary
            discountTotal={order.discountTotal}
            paymentMethodTitle={order.paymentMethodTitle}
            shippingTax={order.shippingTax}
            shippingTotal={order.shippingTotal}
            subTotal={order.subTotal}
            total={order.total}
            totalTax={order.totalTax}
          />
        </div>
      </section>
    </div>
  )
}

export default OrderHistoryDetail
